// eslint-disable-next-line import/no-webpack-loader-syntax
const mockOverlaySource = require('!!raw-loader!./mock-overlay.js');

function addInlineScript(source, id) {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.innerHTML = source;
    document.head.appendChild(script);
  }
  return Promise.resolve();
}

/**
 * 打开 mock overlay
 * @param mocks
 * @return {Promise<*>}
 */
export default async function interceptJsonpWithMocks(mocks) {
  await addInlineScript(mockOverlaySource, '__ZT_MOCK_OVERLAY__');
  return await window.MOCK_OVERLAY({ mocks });
}
